export const Bio = {
  name: "Leela Sagar",
  roles: [
    "Front End Developer",
    "UI/UX Designer",
    "Video Editor",
  ],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/leelasagarFX",
  resume:
    "https://drive.google.com/file/d/131Nath4Za6yhzKTnOj5Y37LwfLUzmUJ9/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/chenji-leela-sagar-847715253/",
  twitter: "https://twitter.com/Emperor_Editz",
  insta: "https://www.instagram.com/lee1asagar/",
  //yt: "https://www.youtube.com/@Emperor_FX",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      // {
      //   name: "Next Js",
      //   image:
      //     "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      // },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      // {
      //   name: "Python",
      //   image:
      //     "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      // },
      // {
      //   name: "Django",
      //   image:
      //     "https://seeklogo.com/images/D/django-logo-4C5ECF7036-seeklogo.com.png",
      // },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      // {
      //   name: "Postgresql",
      //   image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      // },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
    ],
  },
  {
    title: "UI/UX Tools",
    skills: [
      {
        name: "Figma",
        image:
          "https://static-00.iconduck.com/assets.00/figma-icon-1024x1024-mvfh9xsk.png",
      },
      {
        name: "Adobe After Effects",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cb/Adobe_After_Effects_CC_icon.svg/1200px-Adobe_After_Effects_CC_icon.svg.png",
      },
      {
        name: "Adobe Premiere Pro",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/4/40/Adobe_Premiere_Pro_CC_icon.svg/1024px-Adobe_Premiere_Pro_CC_icon.svg.png",
      },
      {
        name: "Adobe Photoshop",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/a/af/Adobe_Photoshop_CC_icon.svg/1200px-Adobe_Photoshop_CC_icon.svg.png",
      },
      // {
      //   name: "Adobe Audition",
      //   image:
      //     "https://seeklogo.com/images/A/adobe-animate-logo-9D0AC83234-seeklogo.com.png",
      // },
      // {
      //   name: "Adobe Lightroom",
      //   image:
      //     "https://upload.wikimedia.org/wikipedia/commons/b/b6/Adobe_Photoshop_Lightroom_CC_logo.svg",
      // },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg",
      },
      {
        name: "GitHub",
        image:
          "https://cdn.pixabay.com/photo/2022/01/30/13/33/github-6980894_1280.png",
      },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://i0.wp.com/analystrelations.org/wp-content/uploads/2021/02/guideline_based_vectors-square.png?w=283&ssl=1",
    role: "Project Intern",
    company: "HCL Enterprises Pvt. Ltd.",
    date: "July 2023 - November 2023",
    desc: "Designing and Developing a Voice-to-Text Tool which helps to convert the speech input into text form, which is very handy and also comes with inbuilt navigation.",
    skills: [
      "HTML",
      "CSS",
      "JavaScript",
    ],
  },
  {
    id: 0,
    img: "https://media.licdn.com/dms/image/D560BAQFV0JYJ33yONg/company-logo_200_200/0/1691701552297/bharat_intern_logo?e=1720051200&v=beta&t=zdZmJ3z7V_0hQVAZieZmo2H9A9KrEntadqLYw6c-OxU",
    role: "Fullstack Developer Intern",
    company: "Bharat Intern",
    date: "January 2024 - February 2024",
    desc: "Designed and developed an Backed Registeration form and a Personal Blog Site with MERN Stack and deployed.",
    skills: [
      "HTML",
      "CSS",
      "JavaScript",
      "NodeJS",
    ],
  },
];

export const education = [
  {
    id: 0,
    img: "https://images.unsplash.com/photo-1712495859694-4e70d095cd5b?q=80&w=1780&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    school: "Sathyabama Institute of Science and Technology, Chennai",
    date: "Oct 2021 - May 2025",
    grade: "9.01 CGPA",
    desc: "I am currently pursuing a Bachelor's degree in Computer Science and Engineering at Sathyabama Institute of Science and Technology, Chennai. I have completed 4 semesters and have a CGPA of 9.0. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others.",
    degree: "Bachelor of Technology - BTech, Computer Science and Engineering",
  },
  {
    id: 1,
    img: "https://asset.brandfetch.io/idtxt2_guu/idtTHffVep.jpeg?updated=1708238013797",
    school: "Sri Chaitanya Educational Institutions, Tirupati",
    date: "Apr 2019 - June 2021",
    grade: "94.7%",
    desc: "I completed my class 12 high school education at Sri Chaitanya Educational Institutions, Tirupati, where the focus was on Mathematics, Physics and Chemistry.",
    degree: "SSC(XII), Maths,Physics,Chemistry",
  },
  {
    id: 2,
    img: "https://images.unsplash.com/photo-1712495738122-b3754cf165d9?q=80&w=1780&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    school: "Kendriya Vidyalaya, Tirupati",
    date: "Apr 2017 - Apr 2019",
    grade: "89.16%",
    desc: "I completed my class 10 education at Kendriya Vidyalaya School, Tirupati.",
    degree: "CBSE(X)",
  },
];

export const projects = [
  {
    id: 9,
    title: "Voice-to-Text Tool",
    date: "July 2023 - November 2023",
    description:
      "A Voice-to-Text Tool which helps to convert the speech input into text form, which is very handy and also comes with inbuilt navigation.",
    image:"https://private-user-images.githubusercontent.com/109415830/318216779-88f3c365-af9d-44e6-8f72-6ffa07894e23.png?jwt=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJnaXRodWIuY29tIiwiYXVkIjoicmF3LmdpdGh1YnVzZXJjb250ZW50LmNvbSIsImtleSI6ImtleTUiLCJleHAiOjE3NDk1NjUyNTgsIm5iZiI6MTc0OTU2NDk1OCwicGF0aCI6Ii8xMDk0MTU4MzAvMzE4MjE2Nzc5LTg4ZjNjMzY1LWFmOWQtNDRlNi04ZjcyLTZmZmEwNzg5NGUyMy5wbmc_WC1BbXotQWxnb3JpdGhtPUFXUzQtSE1BQy1TSEEyNTYmWC1BbXotQ3JlZGVudGlhbD1BS0lBVkNPRFlMU0E1M1BRSzRaQSUyRjIwMjUwNjEwJTJGdXMtZWFzdC0xJTJGczMlMkZhd3M0X3JlcXVlc3QmWC1BbXotRGF0ZT0yMDI1MDYxMFQxNDE1NThaJlgtQW16LUV4cGlyZXM9MzAwJlgtQW16LVNpZ25hdHVyZT03ZWY1YzNiNDFjOGU2MDI1ODdlZDI2NzRiZjFlYzBhOTlmZjNmZjE2YTQzYmU5ODE2OGUzMmUzN2FlZDQ4YTIyJlgtQW16LVNpZ25lZEhlYWRlcnM9aG9zdCJ9.Off3PrL544mWNR7K3O6VuiFvrQRjlN8POl4MY34ZnEQ",
    tags: [
      "HTML",
      "Css",
      "JavaScript",
    ],
    category: "web app",
    github: "https://github.com/leelasagarFX/Voice_Text",
    webapp: "https://github.com/leelasagarFX/Voice_Text",
  },
];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
